<div class="d-flex flex-wrap">
  <span class="btn btn-sm">Force:</span>
  <era-device-mdm-sync-force-ui id="textbox"
                                [allowForce]="isAuthorized$ | async"
                                (forceSync)="updateForceSync($event)"></era-device-mdm-sync-force-ui>
</div>